<template>

  <t-page>

    <TypeEnterpriseDialog :no-option-add="noOptionAdd" @onSubmit="onTypeEnterpriseDialog"/>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-input v-model="form.enterpriseId" hidden/>

        <t-form-tab title="Dados Básicos">

          <t-form-card title="Local" icon-info-square>

            <b-row>

              <t-input
                  v-model="form.title"
                  :add-error="error.title"
                  cols="9"
                  required
                  label="Título"/>

              <t-input v-model="form.enterpriseCodeLabel"
                       v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                       :add-error="error.enterpriseCodeLabel" upper cols="3"
                       :label="'Cód. ' + currentPage.singularTitle"
                       help="Código inserido manualmente conforme configurado em Mapeamento > Configurações > Parâmetros"
                       required/>

              <t-input v-model="form.enterpriseCodeLabel"
                       v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                       :add-error="error.enterpriseCodeLabel" upper cols="3"
                       fixed
                       :label="'Cód. ' + currentPage.singularTitle"
                       help="Código inserido automaticamente conforme configurado em Mapeamento > Configurações > Parâmetros"
              />


            </b-row>

            <b-row>

              <b-col cols="5" v-if="!form.modelEnterprise">
                <t-input-person customer :status="status" :command="command" required :add-error="error.customerId"
                                v-model="form.customerId"/>
              </b-col>
              <t-input v-model="form.typeEnterpriseId" required cols="5"
                       :options="typeEnterpriseOptions" first-default :add-error="error.typeEnterpriseId"
                       label="Perfil" select>

                <template #no-options="{search}">
                  <b-link @click="addNoOption('modal-type-enterprise',search)">Cadastrar Perfil de Emprendimento
                  </b-link>
                </template>

                <template #input-group-append>
                  <t-button v-show="!isDelete() && !isView()" title="Adicionar Perfil de Emprendimento"
                            @click="openDialogForm('modal-type-enterprise')"
                            icon-plus/>
                </template>

              </t-input>

              <t-input
                  cols="2"
                  v-model="form.otherCodeLabel"
                  :add-error="error.otherCodeLabel"
                  label="Cód. Interno"
                  help="Utilize este campo caso desejar armazenar o código deste empreendimento de outro sistema seu como por exemplo o ERP da sua empresa"/>


            </b-row>

          </t-form-card>

          <t-form-card title="Endereço" icon-building>

            <e-address :address="form.address" not-required :command="command" :status="status"
                       @getApi="getEmbedAddressApi"/>

            <b-link v-if="!isDelete()" @click="importAddressCustomer()">Importar endereço do cliente</b-link>

          </t-form-card>


          <div v-if="entityFieldCustomized('page') !== null">

            <t-form-card title="Campos customizados" v-if="entityFieldCustomized('page').length > 0" icon-box>

              <!--ATENÇÃO NÃO ESQUECER DE UTILIZAR template #default="{status} para funcionamento correto-->
              <t-page-form-field-customized
                  ref="fieldsGeneral"
                  :command="command" :status="status" :user-auth="userAuth"
                  :fields-customizable="entityFieldCustomized('page')"
                  :primary-key="form.enterpriseId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
                  :primary-key-column="fieldKey" foreign-key-column="pageId"
              />

            </t-form-card>

          </div>


          <t-form-card title="Informações Gerais" icon-box>

            <b-row>

              <t-input select :options="typeChecklistOptions"
                       cols="6"
                       first-default
                       v-model="form.preferentialTypeChecklistId"
                       help="Utilize esta opção para pré-selecionar uma inspeção especificada quando selecionar este empreendimento."
                       label="Modelo de Inspeção Preferêncial"/>


              <t-input
                  cols="3"
                  v-model="form.startJob"
                  label="Data início"
                  help="Data início da execução deste empreendimento"
                  date
              />

              <t-input
                  cols="3"
                  v-model="form.finishJob"
                  label="Data término"
                  help="Data término da execução deste empreendimento"
                  date
              />

            </b-row>

            <t-input v-model="form.companyId"
                     :options="companyOptions" first-default :required="!form.modelEnterprise" label="Empresa" select/>

            <t-input v-model="form.note" label="Observações"
                     small="Informações inseridas aqui serão disponibilizadas no relatório de acompanhamento por trabalho, logo abaixo do nome do empreendimento."
                     max-length="500" textarea/>


          </t-form-card>


          <t-form-card title="Dados Adicionais" v-if="accountModule !== 'estate'" icon-folder>

            <e-person :person="form.person" not-required :command="command" :error="error_person"
                      @getApi="getEmbedCNPJApi"
                      :status="status"/>

            <t-input-status text="Empreendimento" class="ml-1" v-model="form.status"/>

          </t-form-card>

          <t-form-card title="Relação com Trabalho" v-if="accountModule !== 'estate'">

            <b-row>

              <t-input select :options="workOptions"
                       cols="6"

                       v-model="form.workId"
                       help="Utilize esta opção para relacionar este empreendimento a algum trabalho."
                       label="Trabalho Relacionado"/>

              <t-input
                  number
                  cols="6"
                  v-model="form.workSequence"
                  help="Utilize esta opção para sequenciar este empreendimento dentro de um trabalho."
                  label="Sequência dentro do trabalho"/>

            </b-row>

          </t-form-card>

          <t-form-card title="Ações especiais">


            <b-form-checkbox class="mb-3" v-model="form.modelEnterprise" switch>
              Habilitar este empreendimento como modelo específico?
              <t-help
                  title="Utilizando esta opção será possível disponibilizar na importação de modelos este empreendimento para importação."/>
            </b-form-checkbox>


            <div class="d-flex">
              <div>Copiar mapeamento:</div>
            </div>

            <t-input-code-label enterprise
                                :status="status"
                                hide-label
                                :command="command"
                                v-model="form.copyMappingEnterpriseId"/>


          </t-form-card>

        </t-form-tab>


        <t-form-tab title="Dados Técnicos">

          <b-row class="mb-2">

            <b-col cols="6">

              <div class="d-flex" style="justify-content: space-between">

                <div>Tipo de Edificação</div>

                <b-form-checkbox v-model="form.typePropertyNotFound" switch>

                  <small>Outro?</small>
                  <t-help
                      title="Caso não encontrar utilize esta opção para inserir um texto livre"/>
                </b-form-checkbox>

              </div>

              <t-input
                  v-model="form.typePropertyId"
                  select
                  :options="typePropertyOptions"
                  hide-label
                  v-show="!form.typePropertyNotFound" />

              <t-input
                  v-show="form.typePropertyNotFound"
                  v-model="form.typePropertyNotFoundOther"
                  hide-label placeholder="Informe o tipo desejado"
              />

            </b-col>

            <b-col cols="6">

              <div class="d-flex" style="justify-content: space-between">

                <div>Tipologia do Imóvel</div>

                <b-form-checkbox v-model="form.typeBuildingUseNotFound" switch>

                  <small>Outro?</small>
                  <t-help
                      title="Caso não encontrar utilize esta opção para inserir um texto livre"/>
                </b-form-checkbox>

              </div>

              <t-input
                  v-model="form.typeBuildingUseId"
                  select
                  :options="typeBuildingUseOptions"
                  hide-label
                  v-show="!form.typeBuildingUseNotFound" />

              <t-input
                  v-show="form.typeBuildingUseNotFound"
                  v-model="form.typeBuildingUseNotFoundOther"
                  hide-label placeholder="Informe o tipo desejado"
              />

            </b-col>

          </b-row>

          <b-row class="mb-2">

            <b-col cols="6">

              <div class="d-flex" style="justify-content: space-between">

                <div>Sistema Construtivo Predominante</div>

                <b-form-checkbox v-model="form.typeStructuralSystemNotFound" switch>

                  <small>Outro?</small>
                  <t-help
                      title="Caso não encontrar utilize esta opção para inserir um texto livre"/>
                </b-form-checkbox>

              </div>

              <t-input
                  v-model="form.typeStructuralSystemId"
                  select
                  :options="typeStructuralSystemOptions"
                  hide-label
                  v-show="!form.typeStructuralSystemNotFound" />

              <t-input
                  v-show="form.typeStructuralSystemNotFound"
                  v-model="form.typeStructuralSystemNotFoundOther"
                  hide-label placeholder="Informe o tipo desejado"
              />

            </b-col>

            <b-col cols="6">

              <div class="d-flex" style="justify-content: space-between">

                <div>Situação do Imóvel</div>

                <b-form-checkbox v-model="form.typePropertyStatusNotFound" switch>

                  <small>Outro?</small>
                  <t-help
                      title="Caso não encontrar utilize esta opção para inserir um texto livre"/>
                </b-form-checkbox>

              </div>

              <t-input
                  v-model="form.typePropertyStatusId"
                  select
                  :options="typePropertyStatusOptions"
                  hide-label
                  v-show="!form.typePropertyStatusNotFound" />

              <t-input
                  v-show="form.typePropertyStatusNotFound"
                  v-model="form.typePropertyStatusNotFoundOther"
                  hide-label placeholder="Informe o tipo desejado"
              />

            </b-col>



          </b-row>

          <b-row class="mb-2">

            <b-col cols="6">

              <div class="d-flex" style="justify-content: space-between">

                <div>Regime de uso e ocupação</div>

                <b-form-checkbox v-model="form.typeOccupancyNotFound" switch>

                  <small>Outro?</small>
                  <t-help
                      title="Caso não encontrar utilize esta opção para inserir um texto livre"/>
                </b-form-checkbox>

              </div>

              <t-input
                  v-model="form.typeOccupancyId"
                  select
                  :options="typeOccupancyOptions"
                  hide-label
                  v-show="!form.typeOccupancyNotFound" />

              <t-input
                  v-show="form.typeOccupancyNotFound"
                  v-model="form.typeOccupancyNotFoundOther"
                  hide-label placeholder="Informe o tipo desejado"
              />

            </b-col>

            <b-col cols="6">

              <div class="d-flex" style="justify-content: space-between">

                <div>Situação Legal do Imóvel</div>

                <b-form-checkbox v-model="form.typeLegalStatusNotFound" switch>

                  <small>Outro?</small>
                  <t-help
                      title="Caso não encontrar utilize esta opção para inserir um texto livre"/>
                </b-form-checkbox>

              </div>

              <t-input
                  v-model="form.typeLegalStatusId"
                  select
                  :options="typeLegalStatusOptions"
                  hide-label
                  v-show="!form.typeLegalStatusNotFound" />

              <t-input
                  v-show="form.typeLegalStatusNotFound"
                  v-model="form.typeLegalStatusNotFoundOther"
                  hide-label placeholder="Informe o tipo desejado"
              />

            </b-col>

          </b-row>

          <b-row>

            <b-col cols="6">

              <t-input
                  v-model="form.buildingYear"
                  number
                  label="Ano de Construção"
                  placeholder="0000"
              />

              <t-input
                  hide-label
                  radio
                  :options="BuildYearType.list"
                  v-model="form.typeBuildingYear"
              />

            </b-col>

            <t-input
                label="Intensidade de Uso"
                radio
                cols="6"
                :options="UsageIntensityType.list"
                v-model="form.typeUsageIntensity"
            />


          </b-row>

        </t-form-tab>

      </template>

      <template #out-of-form>

        <t-form-tab title="Mapeamento" hash="mapping"
                    :disabled="!relationAccessPageGeneral('place-enterprise-division')" lazy>
          <EnterpriseDivision :foreign-key="form.enterpriseId"/>
        </t-form-tab>

        <t-form-tab :title="accountModule === 'estate' ? 'Partes do Contrato' : 'Contatos'" hash="contact"
                    :disabled="!relationAccessPageGeneral('place-enterprise-contact')" lazy>
          <EnterpriseContact :foreign-key="form[fieldKey]"/>
        </t-form-tab>

        <t-form-tab title="Fases" v-if="accountModule === 'arch'" hash="step"
                    :disabled="!relationAccessPageGeneral('place-enterprise-step')" lazy>
          <EnterpriseStep :foreign-key="form.enterpriseId"/>
        </t-form-tab>

        <t-form-tab title="Responsabilizar" v-if="accountModule === 'arch' || accountModule === 'condo'"
                    hash="sector-executor"
                    :disabled="!relationAccessPageGeneral('place-enterprise-sector-executor')" lazy>
          <EnterpriseSectorExecutor :foreign-key="form.enterpriseId"/>
        </t-form-tab>

        <t-form-tab title="Conteúdo" hash="content"
                    :disabled="!relationAccessPageGeneral('place-enterprise-content')" lazy>

          <t-msg info class="mb-3">Cadastre conteúdos para serem inseridos junto com os relatórios fotográficos
            relacionados a este empreendimento, podendo especificar no início ou no final a exibição do conteúdo.
          </t-msg>

          <EnterpriseContent :foreign-key="form.enterpriseId"/>

        </t-form-tab>

        <t-form-tab title="Anexos" hash="file" :disabled="!relationAccessPageGeneral('place-enterprise-file')" lazy>

          <t-msg info class="mb-3">Informe se deseja que os anexos fiquem disponíveis publicamente através do link URL
            QR Code.
            <br/>Ressaltamos que irá funcionar, somente se o pavimento do link relacionados estiver habilitado para
            acesso e além disso a política global de acesso via QR Code não esteja restringindo o acesso.
          </t-msg>

          <t-form-card class="mt-2" title="Arquivos">
            <EnterpriseFile :foreign-key="form[fieldKey]"/>
          </t-form-card>

          <t-form-card title="Imagens">
            <EnterpriseFile type-image :foreign-key="form[fieldKey]"/>
          </t-form-card>

        </t-form-tab>

        <t-form-tab title="Links" hash="link" :disabled="!relationAccessPageGeneral('place-enterprise-link')" lazy>
          <EnterpriseLink :foreign-key="form[fieldKey]"/>
        </t-form-tab>

        <t-form-tab title="Comentários" hash="comment" :disabled="validationCommentOption === 0" lazy>

          <Comment :foreign-key="currentPage.pageId" :relation-key="form[fieldKey]"
                   enable-sharing
                   sharing-help="Utilize a opção 'público', quando desejar disponibilizar este comentário a todos as pessoas que possuirem acesso ao link dos locais habilitados."
                   disabled-category
                   disabled-keyword/>
        </t-form-tab>

      </template>


    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ePerson from "@/views/embed/general/e-person";
import eAddress from "@/views/embed/general/e-address";
import TypeEnterpriseDialog from "@/views/modules/place/TypeEnterpriseDialog";
import typeEnterpriseService from "@/services/modules/place/TypeEnterprise.service";
import SettingType from "@/model/types/resource/SettingType";
import EnterpriseDivision from "@/views/modules/place/EnterpriseDivision";
import EnterpriseStep from "@/views/modules/place/EnterpriseStep";
import EnterpriseContent from "@/views/modules/place/EnterpriseContent";
import EnterpriseLink from "@/views/modules/place/EnterpriseLink";
import EnterpriseContact from "@/views/modules/place/EnterpriseContact";
import EnterpriseSectorExecutor from "@/views/modules/place/EnterpriseSectorExecutor";
import EnterpriseFile from "@/views/modules/place/EnterpriseFile";
import Comment from "@/views/modules/general/Comment";
import TypeChecklistModelService from "@/services/modules/checklist/TypeChecklistModel.service";
import CustomerService from "@/services/modules/customer/Customer.service";
import WorkService from "@/services/modules/place/Work.service";
import BuildYearType from "@/model/types/modules/place/BuildYearType";
import UsageIntensityType from "@/model/types/modules/place/UsageIntensityType";


import ui from "@/assets/scripts/ui";
import companyService from "@/services/modules/admin/Company.service";
import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  components: {
    ePerson,
    eAddress,
    TypeEnterpriseDialog,
    EnterpriseDivision,
    EnterpriseStep,
    EnterpriseLink,
    EnterpriseContact,
    EnterpriseSectorExecutor,
    EnterpriseFile,
    EnterpriseContent,
    Comment,
  },
  name: 'EnterpriseForm',
  data() {
    return {
      SettingType,
      BuildYearType,
      UsageIntensityType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "enterpriseId",
      enableGeneralFields: true,
      form: {
        enterpriseId: 0,
        enterpriseNumber: 0,
        companyId: 0,
        enterpriseCodeLabel: "",
        workId: 0,
        workSequence: 0,
        customerId: 0,
        title: "",
        typeEnterpriseId: 0,
        startJob: "",
        finishJob: "",
        otherCodeLabel: "",
        preferentialTypeChecklistId: 0,
        modelEnterprise: false,
        copyMappingEnterpriseId: 0,
        insertExecutorList: [], /*Lista utilizada para inclusões via planilha, onde é enviado uma lista de responsáveis para inclusão*/
        person: {
          /*Embed Person version: 1.0*/
          typePerson: 2,
          name: "",
          shortName: "",
          companyName: "",
          federalTaxpayer: "",
          otherPersonalDocument: "",
          provinceTaxpayer: "",
          provinceTaxpayerExempted: true,
          cityTaxpayer: "",
          /*-------------------------*/
        },
        address: {
          /*Embed Address version: 1.0*/
          country: "BR",
          zipcode: "",
          street: "",
          number: "",
          complement: "",
          neighborhood: "",
          provinceAbbreviation: "",
          cityId: 0
          /*-------------------------*/
        },
        typeBuildingUseId: 0,
        typeLegalStatusId: 0,
        typeOccupancyId: 0,
        typePropertyId: 0,
        typeStructuralSystemId: 0,
        typePropertyStatusId: 0,
        typeBuildingUseNotFoundOther: "",
        typeLegalStatusNotFoundOther: "",
        typeOccupancyNotFoundOther: "",
        typePropertyNotFoundOther: "",
        typeStructuralSystemNotFoundOther: "",
        typePropertyStatusNotFoundOther: "",
        typeBuildingUseNotFound: false,
        typeLegalStatusNotFound: false,
        typeOccupancyNotFound: false,
        typePropertyNotFound: false,
        typePropertyStatusNotFound: false,
        typeStructuralSystemNotFound: false,
        typeUsageIntensity: 0,
        typeBuildingYear: BuildYearType.type.EXACT,
        buildingYear: null,
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        enterpriseCodeLabel: "",
        typeEnterpriseId: "",
        otherCodeLabel: "",
        title: "",
      },
      /*Embed Person Errors version: 1.0*/
      error_person: {
        name: "",
        federalTaxpayer: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      accountModule: "",
      validationCommentOption: 0,
      modeCodeLabel: "",
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      typeBuildingUseOptions: [],
      typePropertyOptions: [],
      typePropertyStatusOptions: [],
      typeStructuralSystemOptions: [],
      typeOccupancyOptions: [],
      typeLegalStatusOptions: [],
      typeEnterpriseOptions: [],
      typeChecklistOptions: [],
      workOptions: [],
      companyOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {
      this.accountModule = ui.getAccountModule()
    },
    async mountedContinued() {

      this.validationCommentOption = this.getRenderRule('validationCommentOption')
      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await typeEnterpriseService.selectList().then((list) => {
        this.typeEnterpriseOptions = list
      }).catch(error => this.responseError(error))

      await TypeChecklistModelService.selectList().then((list) => {
        this.typeChecklistOptions = list
      }).catch(error => this.responseError(error))

      await WorkService.selectList().then((list) => {
        this.workOptions = list
      }).catch(error => this.responseError(error))

      await companyService.selectList("").then((list) => {
        this.companyOptions = list
      }).catch(error => this.responseError(error))

      await http.list(this.userAuth.currentPage.path + "/selectRelationList").then((response) => {

        this.typeBuildingUseOptions = response.typeBuildingUseOptions
        this.typePropertyOptions = response.typePropertyOptions
        this.typePropertyStatusOptions = response.typePropertyStatusOptions
        this.typeStructuralSystemOptions = response.typeStructuralSystemOptions
        this.typeOccupancyOptions = response.typeOccupancyOptions
        this.typeLegalStatusOptions = response.typeLegalStatusOptions

      }).catch(error => this.responseError(error))

    },
    async onSubmit() {
      await this.setSendingDefault()
    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    onTypeEnterpriseDialog(itemInserted) {

      this.form.typeEnterpriseId = itemInserted.value
      this.typeEnterpriseOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    async importAddressCustomer() {

      if (this.form.customerId > 0) {

        if (this.form.address.street !== '') {
          ui.msgConfirm(this, 'Confirmação de importação de endereço', 'Tem certeza que seja importar os dados?<br />Obs.: Os dados atuais de endereço serão substituidos.', async () => {
            await this.importAddressCustomerAux()
          })
        } else {
          await this.importAddressCustomerAux()
        }

      } else {

        ui.msgError(this, 'Selecione um cliente antes de tentar importar o endereço')

      }

    },

    async importAddressCustomerAux() {

      await CustomerService.getResume('id', this.form.customerId).then(resume => {

        this.form.address.street = resume.street
        this.form.address.number = resume.number
        this.form.address.neighborhood = resume.neighborhood
        this.form.address.cityId = resume.cityId
        this.form.address.complement = resume.complement
        this.form.address.zipcode = resume.zipcode
        this.form.address.provinceAbbreviation = resume.provinceAbbreviation


      }).catch(error => {

        if (error.response) {
          if (error.response.status === 500) {
            ui.msg(this, 'Informação', error.response.data.message)
          }
        } else if (error !== '') {
          ui.msg(this, "Erro", error)
        }
      })

    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm()

    await this.mountedContinued()

  },

}
</script>
